import { DatePipe, NgClass } from "@angular/common"
import { Component, computed, input } from "@angular/core"
import { Field } from "@angular/forms/signals"
import { DateRange, MatDatepickerModule } from "@angular/material/datepicker"

@Component({
    selector: "valben-date-range-picker",
    templateUrl: "./date-range-picker.component.html",
    standalone: true,
    imports: [DatePipe, NgClass, MatDatepickerModule],
})
export class DateRangePickerComponent {
    startField = input.required<Field<string, string>>()
    endField = input.required<Field<string, string>>()

    title = input("Datum početka i završetka")
    optional = input(true)
    showTodayButton = input(true)
    minDate = input<Date | undefined>(undefined)
    maxDate = input<Date | undefined>(undefined)

    startDate = computed(() => this._parse(this.startField()().value()))
    endDate = computed(() => this._parse(this.endField()().value()))
    startAt = computed(() => this.startDate() ?? this.endDate() ?? null)
    selectedRange = computed(() => new DateRange(this.startDate() ?? null, this.endDate() ?? null))
    hasError = computed(() => this.startField()().invalid() || this.endField()().invalid())
    selectingEnd = computed(() => !!this.startDate() && !this.endDate())

    onSelect(date: Date | null): void {
        if (!date) return

        const start = this.startDate()
        const end = this.endDate()

        if (!start || end) {
            this._setDate(this.startField(), date)
            this._setDate(this.endField(), undefined)
            return
        }

        if (date.getTime() < start.getTime()) {
            this._setDate(this.startField(), date)
            this._setDate(this.endField(), start)
        } else {
            this._setDate(this.endField(), date)
        }
    }

    onClear(): void {
        this._setDate(this.startField(), undefined)
        this._setDate(this.endField(), undefined)
    }

    setToday(): void {
        this.onSelect(new Date())
    }

    private _setDate(field: Field<string, string>, date: Date | undefined): void {
        const state = field()
        state.value.set(date ? date.toISOString() : "")
        state.markAsDirty()
        state.markAsTouched()
    }

    private _parse(value: string | Date | null | undefined): Date | undefined {
        if (!value) return undefined
        if (value instanceof Date) return Number.isNaN(value.getTime()) ? undefined : value

        const parsed = new Date(value)
        return Number.isNaN(parsed.getTime()) ? undefined : parsed
    }
}
